import _ from "lodash";
import moment from "moment";
import React, {useEffect, useState} from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { Button } from "semantic-ui-react";
import "../../assets/style/global-leave.scss";
import { commonConstants } from "../../core/constant/common.constants";
import "./style.scss";

const MyDetailRequest = (props) => {
    const { leaveDetail, isloading } = props;
    const { t } = useTranslation();
    const history = useHistory();
    const [workLog, setWorkLog] = useState([]);
    let dataDetail = _.assign(leaveDetail);
    const listApprover = dataDetail.approver2Name;
    const status = commonConstants.LEAVE_TYPE_DATA_DETAIL[dataDetail.status];
    const timeFrom = moment(dataDetail.dayFrom).format("HH:mm");
    const timeTo = moment(dataDetail.dayTo).format("HH:mm");
    const dayFrom = moment(dataDetail.dayFrom).format("DD/MM/YYYY");
    const dayTo = moment(dataDetail.dayTo).format("DD/MM/YYYY");
    const handeleCancel = () => {
        history.push("/my-leave-request");
    };

    useEffect(() => {
        const log = [];
        const logWorkToArr = () => {
            for (const property in dataDetail.workLog) {
                const _workLog = { date: property, hours: dataDetail.workLog[property] };
                log.push(_workLog);
            }
        };
        logWorkToArr();
        setWorkLog(log);
      }, [dataDetail.workLog]);
      const eleWorkLog = workLog.map((item, index) => {
        return (
            <div className="wrapper" key={index}>
                {moment(item.date).isoWeekday() === 6 || moment(item.date).isoWeekday() === 7 ? (
                    <div className="wrapper-input">
                        <p className="weekend">
                            {moment(item.date)
                                .locale(localStorage.getItem("i18nextLng") === "en" ? "en" : "vi")
                                .format("ddd, DD/MM/YYYY")}
                        </p>
                        <p className="hours">{item.hours} </p>
                    </div>
                ) : (
                    <div className="wrapper-input">
                        <p className="week">
                            {moment(item.date)
                                .locale(localStorage.getItem("i18nextLng") === "en" ? "en" : "vi")
                                .format("ddd, DD/MM/YYYY")}
                        </p>
                        <p className="hours"> {item.hours} </p>
                    </div>
                )}
            </div>
        );
      });
      console.log(workLog);
    return (
        <div className="my-leave-detail">
            <div className="my-leave-detail-wrapper">
                <h4 className="leave-title">{t("labels.workflowInformation")}</h4>
                <div className="my-leave-detail-wrapper-content">
                    <div className="form-group">
                        <p className="text">{t("labels.requestBy")}:</p>
                        {isloading && <p className="text">{dataDetail.requestByName}</p>}
                    </div>
                    <div className="form-group">
                        <p className="text">{t("labels.requestFor")}:</p>
                        {isloading && <p className="text">{dataDetail.requestForName}</p>}
                    </div>
                    <div className="form-group">
                        <p className="text">{t("labels.managerLeader")}:</p>
                        {isloading && <p className="text">{dataDetail.approver1Name}</p>}
                    </div>
                    <div className="form-group">
                        <p className="text">{t("labels.ccList")}:</p>
                        {isloading && (
                            <div className="form-group list-approver">
                                {listApprover &&
                                    listApprover.map((item, index) => {
                                        return (
                                            <p key={index} className="text">
                                                {item}
                                            </p>
                                        );
                                    })}
                            </div>
                        )}
                    </div>
                </div>
            </div>
            <div className="my-leave-detail-wrapper">
                <h4 className="leave-title">{t("labels.leaveRequestInformation")}</h4>
                <div className="my-leave-detail-wrapper-content leave-request">
                    <div className="form-group">
                        <div className="form-left">
                            <p className="text">{t("labels.leaveTypeDetail")}:</p>
                        </div>
                        <div className="form-right">
                            <div className="form-input">
                                {isloading && <p className="text">{dataDetail.leaveTypeName}</p>}
                            </div>
                        </div>
                    </div>
                    <div className="form-group">
                        <div className="form-left">
                            <p className="text">{t("labels.leaveFromDate")}:</p>
                        </div>
                        <div className="form-right">
                            <div className="form-input">
                                {isloading && <p className="text">{dayFrom}</p>}</div>
                            <div className="remaining-wrapper">
                                <div className="remaining-left">
                                    <p className="text">{t("labels.leaveToDate")}:</p>
                                </div>
                                <div className="remaining-right">
                                    <div className="form-input">
                                        {isloading && <p className="text">{dayTo}</p>}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="form-group">
                        <div className="form-left">
                            <p className="text">{t("labels.leaveFromTime")}:</p>
                        </div>
                        <div className="form-right">
                            <div className="form-input">
                                {isloading && <p className="text">{timeFrom}</p>}</div>
                            <div className="remaining-wrapper">
                                <div className="remaining-left">
                                    <p className="text">{t("labels.leaveToTime")}:</p>
                                </div>
                                <div className="remaining-right">
                                    <div className="form-input">
                                        {isloading && <p className="text">{timeTo}</p>}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="form-group">
                        <div className="form-left">
                            <p className="text">{t("labels.requestTimeOff")}:</p>
                        </div>
                        <div className="form-right">
                            <div className="form-input">
                                {isloading && (
                                    <p className="text">
                                        {dataDetail.requestTimeOff} {t("labels.dayRequestTime")}
                                    </p>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="form-group form-group-textarea">
                        <div className="form-left">
                            <p className="text">{t("labels.leaveReason")}:</p>
                        </div>
                        <div className="form-right">
                            {isloading && <p className="text">{dataDetail.leaveReason}</p>}
                        </div>
                    </div>
                    <div className="form-group form-group-textarea">
                        <div className="form-left">
                            <p className="text">{t("labels.comment")}:</p>
                        </div>
                        <div className="form-right">
                            {isloading && <p className="text">{dataDetail.comment}</p>}</div>
                    </div>
                    <div className="form-group">
                        <div className="form-left">
                            <p className="text">{t("labels.status")}:</p>
                        </div>
                        <div className="form-right">
                            <div className="form-input">
                                {isloading && <p className="text required">
                                    {status && t(`labels.${status}`)}</p>}
                            </div>
                        </div>
                    </div>
                    <div className="form-group form-group-textarea ">
                        <div className="form-left">
                            <p className="text">{t("labels.forLogWork")}:</p>
                        </div>
                        <div className="form-right for-logwork ">
                            <div className="form-input list-week">{isloading && eleWorkLog}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="btn-wrapper">
                <Button onClick={handeleCancel} className="right">
                    {t("button.cancel")}
                </Button>
            </div>
        </div>
    );
};

export default MyDetailRequest;
